import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import LoginForm from '../../components/Auth/LoginForm';
import { useAuth } from '../../contexts/AuthContext';

interface LoginData {
  email: string;
  password: string;
  rememberMe?: boolean;
}

const LoginPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>('');
  const [successMessage, setSuccessMessage] = useState<string>('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Verificar se há mensagem de sucesso na URL
  useEffect(() => {
    const message = searchParams.get('message');
    if (message) {
      setSuccessMessage(message);
    }
  }, [searchParams]);

  const handleLogin = async (data: LoginData) => {
    setIsLoading(true);
    setError('');

    try {
      await login(data.email, data.password, data.rememberMe ?? true);
      navigate('/app/dashboard');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao fazer login');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      {/* Content */}
      <div className="w-full max-w-md">
        {/* Full navigation: / is static HTML landing, not a React route */}
        <a
          href="/"
          className="mb-6 inline-flex items-center gap-2 text-sm font-semibold text-secondary transition-colors hover:text-secondary/80"
        >
          <ArrowLeftIcon className="h-4 w-4" />
          Voltar para a página principal
        </a>
        <LoginForm 
          onSubmit={handleLogin}
          isLoading={isLoading}
          error={error}
          successMessage={successMessage}
        />
      </div>
    </div>
  );
};

export default LoginPage;
